import type {PayloadAction} from "@reduxjs/toolkit";
import {createSlice} from "@reduxjs/toolkit";

export interface IAuthStore {
    redirectPath: string | null;
    allowAuthenticatedRoutes: boolean;
}

const initialState: IAuthStore = {
    redirectPath: null,
    allowAuthenticatedRoutes: true
};

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setRedirectPath: (state, action: PayloadAction<IAuthStore["redirectPath"]>) => {
            return {...state, redirectPath: action.payload};
        },
        setAllowAuthenticatedRoutes: (state, action: PayloadAction<IAuthStore["allowAuthenticatedRoutes"]>) => {
            return {...state, allowAuthenticatedRoutes: action.payload};
        }
    }
});

export const {setRedirectPath, setAllowAuthenticatedRoutes} = authSlice.actions;
import type {PayloadAction} from "@reduxjs/toolkit";
import {createSlice} from "@reduxjs/toolkit";

export interface IAuthStore {
    redirectPath: string | null;
    allowAuthenticatedRoutes: boolean;
}

const initialState: IAuthStore = {
    redirectPath: null,
    allowAuthenticatedRoutes: true
};

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setRedirectPath: (state, action: PayloadAction<IAuthStore["redirectPath"]>) => {
            return {...state, redirectPath: action.payload};
        },
        setAllowAuthenticatedRoutes: (state, action: PayloadAction<IAuthStore["allowAuthenticatedRoutes"]>) => {
            return {...state, allowAuthenticatedRoutes: action.payload};
        }
    }
});

export const {setRedirectPath, setAllowAuthenticatedRoutes} = authSlice.actions;
